<style scoped lang="stylus" rel="stylesheet/stylus">
themeBlue = #266BFF
.picker-time-range
  font-size 17px

  /deep/ .van-picker-column__item
    font-size 17px
  /deep/ .van-picker-column__item--selected
    color themeBlue
  /deep/ .van-popup--bottom
    background-color #F7F7F7
    border-radius 10px 10px 0 0

  .header
    position relative
    height 55px
    font-size 13px
    .title
      padding 0 20px
      color #969799
    .checked
      color #323233
    .underline
      position absolute
      bottom 0
      overflow hidden
      transition 0.3s
      div
        width 16px
        height 4px
        background-color themeBlue
    .tip
      flex 1
      text-align right
      padding-right 15px
      font-size 13px
      color #C8C9CC
      white-space nowrap
      overflow hidden
      text-overflow ellipsis
      line-height 2em

  .container
    background-color #FFFFFF

  .confirm
    height 56px
    line-height 56px
    background-color #FFFFFF
    margin-top 12px
</style>

<template>
	<div class="picker-time-range">
		<van-popup v-model="show" :close-on-click-overlay="false" position="bottom" @click-overlay="cancel">
			<div class="flex-row-sta-cen header">
				<div
					v-for="(title, index) of titles"
					class="title"
					:class="{ checked: currTitle === index }"
					:id="title.id"
					:key="title.id"
					@click="choiceTitle(index)"
				>
					{{ title.text }}
				</div>
				<div class="flex-row-cen-cen underline" :style="underline"><div></div></div>
				<div v-if="tip" class="tip">{{ tip }}</div>
			</div>

			<div class="container">
				<van-picker
					v-show="currTitle === 0"
					ref="startPicker"
					:columns="startTimeColumns"
					:show-toolbar="false"
					@change="startTimeChange"
				></van-picker>
				<van-picker
					v-show="currTitle === 1"
					ref="endPicker"
					:columns="endTimeColumns"
					:show-toolbar="false"
					@change="endTimeChange"
				></van-picker>
			</div>

			<div class="confirm" @click="confirm">完成</div>
		</van-popup>
	</div>
</template>

<script>
import Time from '../time'

export default {
	name: 'pickerTimeRange',
	components: {},
	model: {
		prop: 'show',
		event: 'close'
	},
	props: {
		show: {
			// 控制弹窗显示
			type: Boolean,
			default: false
		},
		initStartTime: {
			type: String,
			default: new Date().format('YYYY-MM-dd')
		},
		initEndTime: {
			type: String,
			default: new Date().format()
		},
		minTime: {
			type: String,
			default: null
		},
		maxTime: {
			type: String,
			default: new Date().format()
		},
		type: {
			// 精确到:天(day)时(hour)
			type: String,
			default: 'hour'
		},
		tip: {
			// 提示信息
			type: String,
			default: null
		}
	},
	data() {
		return {
			titles: [
				// 标题数据
				{ text: '开始时间', id: this.$common.getTimeStampId() },
				{ text: '结束时间', id: this.$common.getTimeStampId() }
			],
			currTitle: 0, // 当前选中标题
			underline: {
				// 标题选中线样式
				width: 0,
				left: 0
			},

			startTime: null,
			startTimeColumns: [],
			startDate: null,
			endTime: null,
			endTimeColumns: [],
			endDate: null
		}
	},
	computed: {},
	mounted() {},
	watch: {
		show() {
			if (this.show) {
				setTimeout(() => {
					this.choiceTitle(this.currTitle)
				})
			}
		}
	},
	created() {
		this.initPickerData()
	},
	methods: {
		initPickerData() {
			let startCurrTime = this.initStartTime
			let startMaxTime = this.maxTime
			this.startTime = new Time({
				minTime: this.minTime,
				currTime: startCurrTime,
				maxTime: startMaxTime
			})
			this.startTimeColumns = this.getColumns(this.startTime)
			this.startDate = this.startTime.currDate
			this.endTime = new Time({
				minTime: startCurrTime,
				currTime: startMaxTime,
				maxTime: startMaxTime
			})
			this.endTimeColumns = this.getColumns(this.endTime)
			this.endDate = this.endTime.currDate
		},
		resetPickerData() {
			let startCurrTime = this.startDate.format()
			let startMaxTime = new Date().format()
			this.startTime = new Time({
				currTime: startCurrTime,
				maxTime: startMaxTime
			})
			this.setCloumns(this.startTime, this.$refs.startPicker)
			let endCurrTime = this.endDate.format()
			this.endTime = new Time({
				minTime: startCurrTime,
				currTime: endCurrTime,
				maxTime: startMaxTime
			})
			this.setCloumns(this.endTime, this.$refs.endPicker)
		},
		startTimeChange(e, value, index) {
			this.changeColumns(e, value, index, this.startTime, this.$refs.startPicker)
			this.endTime.changeMinTime(this.startTime.currDate.format())
			this.setCloumns(this.endTime, this.$refs.endPicker)
		},
		endTimeChange(e, value, index) {
			this.changeColumns(e, value, index, this.endTime, this.$refs.endPicker)
			this.startTime.changeMaxTime(this.endTime.currDate.format())
			this.setCloumns(this.startTime, this.$refs.startPicker)
		},
		changeColumns(e, value, index, time, refPicker) {
			let itemValue = value[index]
			let itemIndex = e.children[index].currentIndex
			switch (index) {
				case 0:
					time.changeYear(itemValue, itemIndex)
					break
				case 1:
					time.changeMonth(itemValue, itemIndex)
					break
				case 2:
					time.changeDay(itemValue, itemIndex)
					break
				case 3:
					time.changeHour(itemValue, itemIndex)
					break
			}
			this.setCloumns(time, refPicker)
		},
		setCloumns(time, refPicker) {
			Object.values(time.timeArr).forEach((value, index) => refPicker.setColumnValues(index, value))
			refPicker.setIndexes(Object.values(time.timeIndex))
		},
		// 切换选择项
		choiceTitle(index) {
			this.currTitle = index
			let id = this.titles[index].id
			let elem = document.getElementById(id)
			this.underline = {
				width: elem.clientWidth + 'px',
				left: elem.offsetLeft + 'px'
			}
		},
		getColumns(time) {
			let columns = [
				{ values: time.timeArr.year, defaultIndex: time.timeIndex.year },
				{ values: time.timeArr.month, defaultIndex: time.timeIndex.month },
				{ values: time.timeArr.day, defaultIndex: time.timeIndex.day }
			]
			if (this.type === 'hour') {
				columns.push({ values: time.timeArr.hour, defaultIndex: time.timeIndex.hour })
			}
			return columns
		},
		// 确认完成返回选中数据
		confirm() {
			this.close()
			this.startDate = this.startTime.currDate
			this.endDate = this.endTime.currDate
			this.$emit('confirm', { startTime: this.startDate.format(), endTime: this.endDate.format() })
		},
		cancel() {
			this.close()
			this.resetPickerData()
		},
		// 关闭弹窗
		close() {
			this.$emit('close', false)
		}
	}
}
</script>
